module.exports = __webpack_public_path__ + "media/images/emblems/Ederswiler-Blazono-770c898dbf161fbe709f8a367568000b.png";